export default "__VITE_ASSET__D2GQeOKT__"